import { Component, ElementRef, input, signal, viewChild } from '@angular/core';

@Component({
  selector: 'ez-expandable',
  templateUrl: './expandable.component.html',
  styleUrl: './expandable.component.scss',
})
export class ExpandableComponent {
  readonly header = input.required<string>();
  readonly headerFontWeight = input<string>('bold');
  readonly required = input<boolean>(false);
  readonly details = viewChild.required<ElementRef<HTMLDetailsElement>>('details');

  protected isOpen = signal(false);

  protected onToggle(): void {
    this.isOpen.set(this.details().nativeElement.open);
  }
}
